import TyFileList from './TyFileList.vue'
export default TyFileList



// WEBPACK FOOTER //
// ./src/components/ty-file-list/index.js